import { render } from "./DataTabs.vue?vue&type=template&id=0fa86aaf"
import script from "./DataTabs.vue?vue&type=script&lang=js"
export * from "./DataTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__